// website/src/services/adminAuth.js
import { Auth } from '@aws-amplify/auth'

// Cache for admin status to avoid repeated API calls
let adminStatusCache = null

export const checkAdminStatus = async () => {
  // Return cached result if available
  if (adminStatusCache !== null) {
    return adminStatusCache
  }
  
  try {
    // Get current authenticated user for JWT token
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    
    // Call our admin check endpoint
    const response = await fetch(
      'https://rbxpfff97c.execute-api.us-east-1.amazonaws.com/auth/check-admin',
      {
        method: 'GET',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      }
    )
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    
    const data = await response.json()
    
    // Cache the admin status
    adminStatusCache = data.isAdmin
    
    return data.isAdmin
  } catch (error) {
    console.error('Error checking admin status:', error)
    return false
  }
}

// Call this when user logs out to clear cache
export const clearAdminCache = () => {
  adminStatusCache = null
}